import { mixed, number, object, ObjectSchema, string } from 'yup';

import { IndexValue } from '@client/api';

import { intervalValueSchema } from './IntervalValue.schema';

import { transformDateToIsoDateString } from '../yup-customizations';

type IndexType = 'Custom' | 'NorskKPI';

const schema: ObjectSchema<IndexValue> = object({
  interval: intervalValueSchema,
  adjustmentPerInterval: number().nullable().when('type', {
    is: 'Custom',
    then: (schema) => schema.positive().required(),
    otherwise: (schema) => schema.nullable(),
  }),
  startDate: string().required().transform(transformDateToIsoDateString),
  currentAdjustment: number().nullable(),
  lastAdjustmentDate: string().nullable().transform(transformDateToIsoDateString),
  type: mixed<IndexType>().oneOf(['Custom', 'NorskKPI']).nullable(),
  baseIndexDate: string().nullable().transform(transformDateToIsoDateString),
  baseIndexValue: number().nullable(),
}) as ObjectSchema<IndexValue>;

export { schema as indexValueSchema };
